// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SET_VLAN_LIST = 'vlan/SET_VLAN_LIST';
export const SET_VLAN_ITEM = 'vlan/SET_VLAN_ITEM';
export const UNSET_VLAN_ITEM = 'vlan/UNSET_VLAN_ITEM';
export const ADD_VLAN_ITEM = 'vlan/ADD_VLAN_ITEM';
export const UPDATE_VLAN_ITEM = 'vlan/UPDATE_VLAN_ITEM';
export const SET_VLAN_IS_DELETING = 'vlan/SET_VLAN_IS_DELETING';
export const SET_VLAN_IS_LOADING = 'vlan/SET_VLAN_IS_LOADING';
export const REMOVE_VLAN_ITEM = 'vlan/REMOVE_VLAN_ITEM';